export default "__VITE_ASSET__t0fEl1_z__"